import { IResourceRecord } from '../definitions/types'
import { sortRecordsBySortKey } from './sortRecordsBySortKey'
import { IResourceFieldProjector } from './types'

interface ICreateMixedResourceFieldProjectorOptions {
  projectorByType: ReadonlyMap<string, IResourceFieldProjector>
  getRecordTypeId: (record: IResourceRecord) => string
  primary: IResourceFieldProjector
}

// Records of several resource types in one list: each resolves and sorts through its
// own type's projector. The record-less members answer for the primary type.
export const createMixedResourceFieldProjector = ({
  projectorByType,
  getRecordTypeId,
  primary,
}: ICreateMixedResourceFieldProjectorOptions): IResourceFieldProjector => {
  const projectorOf = (record: IResourceRecord) =>
    projectorByType.get(getRecordTypeId(record)) ?? primary
  const getSortKey = (record: IResourceRecord, key: string) =>
    projectorOf(record).getSortKey(record, key)

  return {
    runtimeContext: primary.runtimeContext,
    resolve: (record, key) => projectorOf(record).resolve(record, key),
    fromValue: primary.fromValue,
    fromEntryId: primary.fromEntryId,
    sortRecords: (records, key, order) =>
      sortRecordsBySortKey(records, record => getSortKey(record, key), order),
    getSortKey,
  }
}
